import React from "react";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import {
  selectCurrentPage,
  selectAllLoadsNo,
} from "../../redux/load/load.selectors";
// import { setCurrentPage } from "../../redux/load/load.actions";

import PaginationItem from "../../components/PaginationItem/PaginationItem.component";

const Pagination = ({
  loadRequests_no,
  currentPage,
  all_loads_no,
  // update_currentPage,
  // setCurrentPage,
}) => {
  //   console.log(loadRequests_no);
  //   console.log(currentPage);

  const paginationItem_no = loadRequests_no
    ? Math.ceil(all_loads_no / loadRequests_no)
    : null;

  const load_items = () => {
    let list = [];
    for (let i = currentPage - 3; i <= currentPage + 3; ++i) {
      // const handle_click = () => {
      //   update_currentPage(i);
      // };
      if (i < 1 || i > paginationItem_no) continue;
      list.push(
        <PaginationItem
          key={i}
          number={i}
          content={i}
          current={i === currentPage ? true : false}
          // onClick={handle_click}
        />
      );
    }
    return list;
  };

  // console.log("pagination container");
  // debugger;
  return (
    <div className="container-fluid d-flex justify-content-center align-items-center">
      {/* {console.log(currentPage)} */}
      {/* {console.log("loadRequests_no", loadRequests_no)} */}
      <div className="ml-3 d-sm-block " style={{ display: "none" }}>
        <PaginationItem
          content="اولین"
          number={1}
          // onClick={() => (currentPage > 1 ? update_currentPage(1) : null)}
          className="ml-3"
          border={true}
        />
      </div>

      <div className="ml-3 d-sm-block " style={{ display: "none" }}>
        <PaginationItem
          content="قبلی"
          number={currentPage > 1 ? currentPage - 1 : currentPage}
          // onClick={() =>
          //   currentPage > 1 ? update_currentPage(currentPage - 1) : null
          // }
          className="ml-3"
        />
      </div>

      {load_items()}

      <div className="mr-3 d-sm-block " style={{ display: "none" }}>
        <PaginationItem
          content="بعدی"
          number={
            currentPage < paginationItem_no ? currentPage + 1 : currentPage
          }
          // onClick={() =>
          //   currentPage < paginationItem_no
          //     ? update_currentPage(currentPage + 1)
          //     : null
          // }
          className="mr-3 d-none d-sm-block"
        />
      </div>
    </div>
  );
};

const mapStateToProps = () =>
  createStructuredSelector({
    currentPage: selectCurrentPage,
    all_loads_no: selectAllLoadsNo,
  });

// const mapDispatchToProps = (dispatch) => ({
//   setCurrentPage: (page) => dispatch(setCurrentPage(page)),
// });

export default connect(mapStateToProps)(Pagination);
